import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {
  checkServiceAndGetSubscribers,
  PopUp as PopUpEnum,
  StepsEnum,
  setSelectedSubscriber,
  setStep,
  setIsLoaded,
  saveToHistory,
} from './CellularDataOnOffSlice';
import SelectSubscriber
  from "app/Components/Block/CellularDataOnOff/Steps/SelectSubscriber/SelectSubscriber";
import ToggleStep from "app/Components/Block/CellularDataOnOff/Steps/ToggleStep/ToggleStep";
import CallBackPopUp from "app/Components/Block/CellularDataOnOff/PopUps/CallBackPopUp";
import PopUpWithAnimation from "app/Components/Shared/PopUpWithAnimation/PopUpWithAnimation";
import ErrorBlock from "app/Components/Shared/ErrorPage/ErrorBlock";
import Config from "app/Config";
import authenticationProvider from "app/utilities/authentication/authenticationProvider";
import BuyServiceStep from "app/Components/Block/CellularDataOnOff/Steps/BuyServiceStep/BuyServiceStep";

const CellularDataOnOff = (props) => {

  const {
    isLoaded,
    step,
    popUp,
  } = props.cellularDataOnOffSlice;

  const {setIsLoaded, setStep, checkServiceAndGetSubscribers, saveToHistory, setSelectedSubscriber} = props
  const blockId = props.contentData.contentLink.id;
  const isPaywalled = props.contentData?.isPaywalled?.value === true;

  const {
    isOtpAuthenticated,
    isFullAuthenticated,
    isOtpExtendedAuthenticated,
  } = props.authentication.loginData;

  const init = async () => {
    const { isAuthenticateFinish, loginData } = props.authentication;
    const { IsContactPerson, IsPrimaryContact } = loginData.userDetails;

    if (!isLoaded && isAuthenticateFinish) {
      if (!isOtpAuthenticated && !isFullAuthenticated && !isOtpExtendedAuthenticated) {
        authenticationProvider.redirectToLogin(location.pathname, '');
      } else if (isOtpAuthenticated && (!IsContactPerson || !IsPrimaryContact)) {
        authenticationProvider.redirectToLogin(location.pathname, '');
      } else if (isFullAuthenticated || isOtpExtendedAuthenticated) {
          const res = await checkServiceAndGetSubscribers({ blockId, isPaywalled });
          if (res?.payload?.error) {
            setStep(StepsEnum.ERROR);
            return;
          }
        setIsLoaded(true);
      }
    }
  };



  useEffect(() => {
    init();
  }, [props.authentication.isAuthenticateFinish]);

  function getStep() {
    switch (step) {
      case StepsEnum.SELECT_SUBSCRIBER:
        return <SelectSubscriber/>;
      case StepsEnum.TOGGLE_STEP:
        return <ToggleStep {...props}/>;
      case StepsEnum.ERROR:
        return <ErrorBlock mainTitle='אופס, משהו השתבש!' buttonTitle={'חזרה לאיזור האישי'}
                           buttonLink={Config.lobbyUrl}/>
      case StepsEnum.BUY_SERVICE:
        return <BuyServiceStep{...props}/>;
      default:
        return null;
    }
  }

  function getPopUp() {
    switch (popUp) {
      case PopUpEnum.CALL_BACK:
        return <CallBackPopUp contentData={props.contentData}/>;
      default:
        return null;
    }
  }

  return (
    <div className={'block-and-unblock-browsing-container'}>
      {getStep()}
      <PopUpWithAnimation
        isShow={popUp !== null}
      >
        {getPopUp()}
      </PopUpWithAnimation>
    </div>

  );
};

const mapStateToProps = (state) => {
  return {
    cellularDataOnOffSlice: state.cellularDataOnOffSlice,
    authentication: state.authentication
  };
};

const mapDispatchToProps = {
  checkServiceAndGetSubscribers,
  setSelectedSubscriber,
  setStep,
  setIsLoaded,
  saveToHistory,
};

export default connect(mapStateToProps, mapDispatchToProps)(CellularDataOnOff);
